export default `# Build with AI

Generate code scaffold bundles powered by your session insights, requirements, and design files. Build with AI turns conversation outputs into implementation-ready starter projects.

---

## 3-Step Wizard

### Step 1: Source & Context

Select what context to include in the build:

- **Project** — Choose which project to build from
- **Sessions** — Select one or more sessions (their transcripts, requirements, and personas become available)
- Expand each session to toggle specific items:
  - Transcripts
  - Requirements
  - Personas

The more context you include, the more tailored the generated code will be.

### Step 2: Configure Build

Define the technical setup:

- **Tech Stack** — React, Vue, Angular, etc.
- **CSS Framework** — Tailwind, Bootstrap, etc.
- **Repository Name** — Name for the generated project
- **Additional Instructions** — Free-text guidance for the AI
- **Skills** — Add capability bundles (Testing, DevOps, Design, Engineering, Quality)
  - Use **Smart Defaults** to let the AI select skills based on your context

### Step 3: Review & Launch

Review your selections and launch the build:

- Summary of all choices
- **Build History** — Previous builds for this project with download links
- **Launch** — Submit the build task (runs asynchronously)

---

## What Gets Generated

The build produces:
- **CLAUDE.md** — AI-readable project specification
- **Scaffold code** — Starter project structure based on your tech stack
- **Documentation** — Generated from session requirements and decisions

---

## Tips

- **Include multiple sessions** — Cross-session context produces richer, more complete scaffolds
- **Try Smart Defaults for skills** — The AI usually picks the right bundles based on your project context
- **Download previous builds** from the history section to compare iterations`;
